<template>
    <div>
        <headline-container headline="Create Untracked Email Address" :breadcrumbs="breadcrumbs"></headline-container>
        
        <div class="container">
            <div class="row">
                <div class="col-xs-6">
                    <help-text>
                        <h3>
                            Create Untracked Email Address
                        </h3>

                        <p>
                            Enter the details of the untracked email address. When saved, the system will not track
                            email to or from the given address.
                        </p>
                    </help-text>
                </div>

                <div class="col-xs-18">
                    <div class="panel panel-default">
                        <div class="panel-body">
                            <form @submit.prevent="submit" class="form-horizontal">
                                <text-form-group
                                        v-model="data.address"
                                        name="address"
                                        label="Address"
                                        :error="getError('address')"
                                ></text-form-group>
                                
                                <hr>

                                <submit-form-group button-class="btn-black"></submit-form-group>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import http from '@/http'
    import notify from '@/notify'
    import Errors from '@/mixins/Errors'
    import HeadlineContainer from '@/components/Layout/HeadlineContainer'
    import HelpText from '@/components/HelpText'
    import SubmitFormGroup from '@/vendor/forms/FormGroups/Horizontal/Submit'
    import TextFormGroup from '@/vendor/forms/FormGroups/Horizontal/Text'

    export default {
        components: {HeadlineContainer, HelpText, SubmitFormGroup, TextFormGroup},

        mixins: [Errors],

        data() {
            return {
                data: {}
            }
        },

        computed: {
            breadcrumbs() {
                return [
                    {url: '/untracked-email-addresses', text: 'Untracked Email Addresses'},
                    {text: 'Create'}
                ]
            }
        },

        methods: {
            submit() {
                http.post('/api/v2/untracked-email-addresses', this.data)
                    .then(() => {
                        notify.success('The untracked email address was saved')

                        this.$router.push('/untracked-email-addresses')
                    })
                    .catch(this.catchValidationErrors)
            }
        }
    }
</script>
